/* @flow weak */
import _ from 'lodash';
import isEmail from 'lib/isEmail';
import isPhone from 'lib/isPhone';

const VALID = 'VALID';
const INVALID = 'INVALID';
const UNKNOWN = 'UNKNOWN';

const newToken = recipient => {
  if (isEmail(recipient)) {
    return { value: recipient, address: 'email://' + recipient, status: UNKNOWN };
  } else if (isPhone(recipient)) {
    return { value: recipient, address: 'sms://' + recipient, status: UNKNOWN };
  } else {
    return { value: recipient, address: null, status: INVALID };
  }
};

const parse = (input, ignoreTrailing) => {
  const shouldIgnoreTrailing = ignoreTrailing !== false;

  const recipients = input.split(/[;,\n]+/);
  const results = [];

  if (shouldIgnoreTrailing && recipients.length <= 1) {
    return results;
  }

  _.each(recipients, function(recipient) {
    const trimmedRecipient = recipient.trim();
    if (trimmedRecipient.length > 1) {
      results.push(newToken(trimmedRecipient.trim()));
    }
  });

  return results;
};

export default {
  VALID,
  INVALID,
  UNKNOWN,
  parse,
  newToken,
};
